import useAsync from 'react-use/esm/useAsync';
import { Entity } from '@backstage/catalog-model';
import { CRDProjectCodeConfig } from '@internal/backstage-plugin-compute-resource-discovery-new-common';

/** @public */
export const COMPUTE_RESOURCES_METADATA = 'computeResources';

export const useProjectCode = (entity: Entity) => {
  const { value, loading, error } = useAsync(
    async (): Promise<CRDProjectCodeConfig> => {
      const metadata = entity?.metadata as Record<string, any> | undefined;
      return metadata?.[COMPUTE_RESOURCES_METADATA] ?? {};
    },
  );

  return { value, loading, error };
};
